module.exports = __webpack_public_path__ + "static/img02-72c8036a2a4682d7d81782358c440e3a.png";